const sumDigits = (digits: number | number[], mapper = (i: number) => i) => {
  if (typeof digits == 'number') {
    digits = `${digits}`.split('').map((i) => parseFloat(i));
  }
  return digits.map(mapper).reduce((acc, cur) => acc + cur, 0);
};
  
export const isHappy = (num: number): boolean => {
  const memo = [];
  do {
    num = sumDigits(num, (i) => i ** 2);
    if (memo.includes(num)) {
    return false;
    }
    memo.push(num);
  } while (num != 1);
  return true;
};
  